import { render, staticRenderFns } from "./MainChatBox.vue?vue&type=template&id=60602c72&scoped=true&"
import script from "./MainChatBox.vue?vue&type=script&lang=js&"
export * from "./MainChatBox.vue?vue&type=script&lang=js&"
import style0 from "./MainChatBox.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MainChatBox.vue?vue&type=style&index=1&id=60602c72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60602c72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VIcon,VProgressCircular})
